import { FC } from "react";
import { SessionPartConfig } from "@/mds/components/sessions/session-parts/session-part.types";
import {
  MemCommonMarkdown,
  OnClickMemItem,
  OnMemItemOut,
  OnMemItemOver,
  MemCommonEditorTheme,
} from "@mem-labs/common-editor";
import styled from "@emotion/styled";
import { useTheme } from "@/mds/themes";

type Props = {
  content: string;
  onClickMemItem: OnClickMemItem;
  config: SessionPartConfig;
  onMemItemOver?: OnMemItemOver;
  onMemItemOut?: OnMemItemOut;
  renderLinksAsChips?: boolean;
};

export const SessionMarkdownContent: FC<Props> = ({
  content,
  onClickMemItem,
  config,
  onMemItemOver,
  onMemItemOut,
  renderLinksAsChips,
}: Props) => {
  const { themeType } = useTheme();

  return (
    <MarkdownContent
      onMemItemOver={onMemItemOver}
      onMemItemOut={onMemItemOut}
      onClickMemItem={onClickMemItem}
      openLinksInNewTab={config.openLinksInNewTab}
      prohibitNativeCmdClick={config.prohibitNativeCmdClick}
      renderLinksAsChips={renderLinksAsChips}
      uiTheme={
        themeType === "harvest" ? MemCommonEditorTheme.Harvest : MemCommonEditorTheme.HarvestMoon
      }
    >
      {content}
    </MarkdownContent>
  );
};

const MarkdownContent = styled(MemCommonMarkdown)(({ theme }) => ({
  width: "100%",
  color: theme.colors.text.primary,
}));
